import PropTypes from 'prop-types';
// @ts-expect-error Untyped dependency
import { universalEditableAreas } from './EditableAreas';
// @ts-expect-error Untyped dependency
import { SaveBarContainer } from './SaveBarContainer';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { Column } from 'foundations-components/transitional/components/Column';
import { ColumnWrapper } from 'foundations-components/transitional/components/ColumnWrapper';
import { ColumnSpreads } from 'foundations-components/transitional/components/ColumnSpreads';
import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
import { View } from 'foundations-components/transitional/components/View';
import { StickyFooter } from 'foundations-components/transitional/components/StickyFooter';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const UniversalSaveBar = ({
  children,
  formattedChanges,
  hasErrors,
  isLoading,
  handleSave,
  handleCancel,
  hasChanges
}) => {
  return /*#__PURE__*/_jsx(StickyFooter, {
    "data-selenium-test": "UniversalSaveBar",
    "data-test-id": "universal-save-bar-sticky-footer",
    children: /*#__PURE__*/_jsx(View, {
      backgroundColor: "fill-field-default",
      paddingBlock: "400",
      paddingInline: "1200",
      children: /*#__PURE__*/_jsxs(ColumnWrapper, {
        align: "center",
        children: [/*#__PURE__*/_jsxs(Column, {
          children: [/*#__PURE__*/_jsx(Button, {
            disabled: isLoading || hasErrors || !hasChanges,
            onClick: handleSave,
            "data-selenium-test": "UniversalSaveBar-button-primary",
            use: "primary",
            children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
              message: "customerDataProperties.SaveBar.save"
            })
          }), /*#__PURE__*/_jsx(Button, {
            disabled: !hasChanges,
            "data-selenium-test": "UniversalSaveBar-button",
            onClick: handleCancel,
            marginInlineEnd: "800",
            children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
              message: "customerDataProperties.SaveBar.cancel"
            })
          })]
        }), /*#__PURE__*/_jsxs(ColumnSpreads, {
          children: [children, !children && /*#__PURE__*/_jsx(TruncateString, {
            children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
              message: "customerDataProperties.SaveBar.info",
              options: {
                changes: formattedChanges
              }
            })
          })]
        })]
      })
    })
  });
};
UniversalSaveBar.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  formattedChanges: PropTypes.string,
  hasErrors: PropTypes.bool.isRequired,
  hasChanges: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool.isRequired,
  handleSave: PropTypes.func.isRequired,
  handleCancel: PropTypes.func.isRequired
};
export default SaveBarContainer(UniversalSaveBar, universalEditableAreas);